import { Injectable, Signal, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  private _appError = signal<string>('')

  get appError(): Signal<string> {
    return this._appError.asReadonly();
  }
  
  set appError(error:unknown){ 
    const errorMessage = error instanceof Error ? error.message : String(error);
    this._appError.set('');
    this._appError.set(errorMessage);
  }
}
